<template>
  <div class="myBanner" :class="getClassList()">

    <!--私有横幅-->
    <!--<template v-if="$store.state.myRender.private.banner_type === 'private'">
      <full_screen_banner v-for="(val, i) in $store.state.myRender.full_screen_banner" :banner="val" :key="i" v-if="val.data.type === $store.state.app.view_pattern"></full_screen_banner>
    </template>

    <template v-if="$store.state.myRender.private.banner_type === 'share'">
      <full_screen_banner v-for="(val, i) in $store.state.myRender.common.full_screen_banner" :banner="val" :key="i" v-if="val.data.type === $store.state.app.view_pattern"></full_screen_banner>
    </template>-->
    <template v-if="banner && $store.state.myRender.private.banner_isShow">
      <full_screen_banner :banner='banner' v-if="$store.state.full_screen_banner.isRender"
                          :class="'page_' + $store.state.app.now_page"></full_screen_banner>
    </template>


  </div>
</template>

<script>
import full_screen_banner from '@/widgets/full_screen_banner';

export default {
  name: "banner",
  components: {
    full_screen_banner
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    //移动端上，添加图片的类型，默认就是用pc图片数据，其实就是用pc的col。如果是自定义，就是用移动端自己的col
    //这里的这个值，代表根据各种判断得出的当前横幅的数据
    banner() {
      //预定义横幅的数据
      let data = null;

      //当前模式
      const view_pattern = this.$store.state.app.view_pattern;

      let pc_banner = this.templet.find_banner().pc_banner;
      let mb_banner = this.templet.find_banner().mb_banner;

      if (typeof pc_banner == 'undefined' || typeof mb_banner == 'undefined') {
        return false
      }
      //如果是pc端，直接输出
      if (view_pattern === 'pc') {
        return pc_banner;
      } else {
        //如果是移动端，且增加图片选择的是自定义，则直接输出
        if (mb_banner.data.listArr.add_img === 'custom') {
          return mb_banner;
        }
        //如果是移动端，且增加图片选择的是默认，则获取pc的col，加上mb的data 拼一起输出
        else {
          //特殊模式下，等于输出一个新对象，只不过children和data建立了引用关系
          data = JSON.parse(JSON.stringify(mb_banner));

          //children和data建立引用关系
          data.children = pc_banner.children;
          data.data = mb_banner.data;
          this.$store.commit('full_screen_banner/set_mb_add_img_obj', data);
          return data;
        }
      }
    }
  },
  methods: {
    getClassList() {
      return [
        this.$store.state.app.fullPageAniClass[0],
        (this.$store.state.app.fullPageCurrentIndex === 0 && this.$store.state.myRender.private.banner_isShow) ? 'fullpage-slide-current' : '',
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/public/banner.vue